import React, { FunctionComponent, MouseEvent, PropsWithChildren, ReactElement, ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import './Button.scss'

export interface OwnProps {
  to?: string
  subtext?: string
  icon?: ReactNode
  type?: 'button' | 'submit' | 'reset'
  loading?: boolean
  disabled?: boolean
  propClassName?: string
  onClick?(e: MouseEvent<HTMLButtonElement>): void | Promise<void>
  ariaLabel?: string
  size?: 'small' | 'medium'
}

type Props = PropsWithChildren<OwnProps>

export const Button: FunctionComponent<Props> = ({
  to,
  subtext,
  icon,
  type,
  loading,
  disabled,
  propClassName = '',
  onClick,
  ariaLabel,
  children,
  size,
}: Props): ReactElement => {
  let className = `Button ${propClassName}`
  const navigate = useNavigate()
  if (loading) {
    className += ' is-loading'
  }
  if (subtext) {
    className += ' is-multiline'
  }
  if (icon) {
    className += ' with-icon'
  }

  if (size === 'small') {
    className += ' small'
  }
  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    if (to) {
      navigate(to)
    }
    if (onClick) {
      onClick(e)
    }
  }

  /* eslint-disable react/button-has-type */
  return (
    <button className={className} type={type} disabled={disabled} onClick={handleClick} aria-label={ariaLabel}>
      <span className="Button-icon">{icon}</span>
      <div className="Button-inner">
        {children}
        <span>{subtext}</span>
      </div>
    </button>
  )
}

export default Button
